import { Typography, type TypographyProps } from '../Typography';

interface FullScreenOverlayTitleProps extends InheritProps {}

type InheritProps = Pick<TypographyProps, 'children' | 'id' | 'textAlign' | 'noWrap'>;

export const FullScreenOverlayTitle = (props: FullScreenOverlayTitleProps) => {
    return (
        <Typography
            component="h1"
            {...props}
            typography={{ xs: 'subtitle1', sm: 'h2', md: 'h1' }}
        />
    );
};
